/**
 * Created by mgoria on 11/12/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadCredentialsException = undefined;

var _Exception2 = require('../../Exception/Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let LoadCredentialsException = exports.LoadCredentialsException = function (_Exception) {
  _inherits(LoadCredentialsException, _Exception);

  /**
   * @param {String} exception
   */
  function LoadCredentialsException(exception) {
    _classCallCheck(this, LoadCredentialsException);

    return _possibleConstructorReturn(this, (LoadCredentialsException.__proto__ || Object.getPrototypeOf(LoadCredentialsException)).call(this, `Error on loading security credentials in deep-resource -> request. ${exception}`));
  }

  return LoadCredentialsException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/Exception/LoadCredentialsException.js
// module id = 418
// module chunks = 0